import React from 'react'
import { useTranslation } from 'react-i18next'
import styled, { css } from 'styled-components'

import { CurrencyPairIcons } from '@root/entities/currency/ui'
import { ProviderIcon } from '@root/entities/provider/ui'
import { mediaMinTablet } from '@root/shared/ui-kit'

import type { Pair } from '@root/entities/pair'

type PoolCardMainInfoProps = {
  pool: Pair.PairMinimal
}

export const PoolCardMainInfo: React.FC<PoolCardMainInfoProps> = ({ pool }) => {
  const { t } = useTranslation()
  return (
    <Root>
      <PairContainer>
        <CurrencyPairIcons base={pool.base} quote={pool.quote} size={32} />
        <PairTickers>
          {pool.base.ticker}/{pool.quote.ticker}
        </PairTickers>
      </PairContainer>
      <ProviderContainer>
        <ProviderIcon size={32} provider={pool.provider} />
        <div>
          <ProviderLabel>{t('provider')}</ProviderLabel>
          <ProviderName>{pool.provider.title}</ProviderName>
        </div>
      </ProviderContainer>
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  align-items: center;

  padding-block: 12px;
  padding-inline: 16px;

  ${mediaMinTablet(css`
    padding-inline: 12px;
  `)}

  border-bottom: 1px solid var(--card-separator-color);
`

const PairContainer = styled.div`
  display: grid;
  grid-template-columns: max-content auto;
  gap: 10px;
  align-items: center;
`

const PairTickers = styled.span`
  color: var(--text-12);
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
`

const ProviderContainer = styled.div`
  display: grid;
  grid-template-columns: max-content auto;
  gap: 10px;
  align-items: center;
  justify-self: end;
`

const ProviderLabel = styled.div`
  color: var(--text-9);
  font-size: 12px;
  font-weight: 500;
  line-height: 12px;
`

const ProviderName = styled.span`
  color: var(--text-12);
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
  text-transform: uppercase;
`
